import React from 'react';

const Tag = (props) => {

    const colorPallet = {
        0: '#228B22',
        1: '#E906ED',
        2: '#A0F930',
        3: '#8B0000',
        4: '#003366',
        5: '#4B0082',
        6: '#F2A900',
        7: '#35DDFF',
        8: '#FF5733',
        9: '#33FFBB',
    }

    const categoryColor = colorPallet[props.categorieId % 10];

    return (
        <div
            className="px-2 py-1 mb-1.5 rounded-md mr-2 whitespace-nowrap text-black"
            style={{ border: `3px solid ${categoryColor}` }}
        >
            <div className="text-sm">
                {props.categories.map((categorie) => {
                    return (
                        <React.Fragment>
                            {
                                categorie.id === props.categorieId ?
                                    (
                                        <div>
                                            {categorie.name}
                                        </div>
                                    ) : null
                            }
                        </React.Fragment>
                    )
                })}
            </div>
        </div >
    );
}

export default Tag;